var BufferPromptHandler = require('bufferprompthandler');
var Formatter = require('formatter');


var SessionPromptHandler = BufferPromptHandler.extend({
    initialize: function (options) {
        this.bindMessageHandlers();
        
        this.formatter = new Formatter();
    },
    defaultHead: function () {
        return 'IRCCloud';
    },
    bindMessageHandlers: function () {
        this.model.bind('postError', this.postError, this);
        this.model.bind('inlineImageConfirm', this.inlineImageConfirm, this);
        this.model.bind('inlineMastodonConfirm', this.inlineMastodonConfirm, this);
    },
    inlineImageConfirm: function (callback) {
        var confirmHtml = "Be aware that embedding external media may result in your IP address being revealed to any host on the internet.";
        var overlay = this.htmlConfirm(confirmHtml, _.bind(function () {
            this.model.setPref('inlineimagewarn', true);
            if (callback) {
                callback();
            }
        }, this), {
            okText: 'Turn on external embedding',
            head: 'Embedding external media'
        });
        overlay.className = 'inline_image_confirm';
        this.triggerAdd(overlay);
    },
    inlineMastodonConfirm: function (callback) {
        var confirmHtml = "Be aware that embedding Mastodon links may result in your IP address being revealed to any host on the internet.";
        var overlay = this.htmlConfirm(confirmHtml, _.bind(function () {
            this.model.setPref('inlinemastodonwarn', true);
            if (callback) {
                callback();
            }
        }, this), {
            okText: 'Turn on Mastodon embedding',
            head: 'Embedding Mastodon'
        });
        overlay.className = 'inline_image_confirm';
        this.triggerAdd(overlay);
    }
});


module.exports = SessionPromptHandler;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/sessionprompthandler.js
// module id = Sirl
// module chunks = 1